import React from 'react';
import { useDrop } from 'react-dnd';
import './MatchSchedule.css';

function CrewDropZone({ aboveIndex, belowIndex, onDrop, crewListType }) {
    const [{ isOver }, drop] = useDrop({
        accept: 'CREW_LIST',
        drop: (item) => {
            onDrop(item, aboveIndex, belowIndex, crewListType);
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    });

    return (
        <div
            ref={drop}
            className={`crew-drop-zone ${isOver ? 'is-over' : ''}`}
            style={{
                flex: isOver ? '1 0 40px' : '1 0 10px',
                minHeight: isOver ? '40px' : '10px',
                height:'10px'
            }}
        />
    );
}

export default CrewDropZone;
